module.exports = __webpack_public_path__ + "img/bg.b007a7d2.png";